<template>
    
    <div class="intake-view">
        <div class="card">
			<div class="card-body">
				<div class="m-sm-4">
                    <p class="lead text-center">
                        檢驗報告
                    </p>

                    <div>
                        <div class="mb-3 mb-xl-3">
                            <label class="form-label">送檢日期</label>
                            <input class="form-control" type="date"
                                :value="$shared.formatIosDate(applyData.form_send_time)"
                                :disabled="true"
                            />
                        </div>

                        <div class="mb-3 mb-xl-3">
                            <label class="form-label">檢驗類型</label>
                            <input class="form-control" type="text"
                                :value="getExamTypeName(applyData.exam_type)"
                                :disabled="true"
                            />
                        </div>

                        <div class="mb-3 mb-xl-3">
                            <label class="form-label">檢體類型</label>
                            <input class="form-control" type="text"
                                :value="getSpecimenTypeName(applyData.specimen_type)"
                                :disabled="true"
                            />
                        </div>

                        <div class="mb-3 mb-xl-3">
                            <label class="form-label">送檢單位</label>
                            <input class="form-control" type="text"
                                :value="getExamUnitName(applyData.exam_unit)"
                                :disabled="true"
                            />
                        </div>

                        <div class="block-box mb-3 mb-xl-3">
                            <span class="block-title">送檢表單</span>
                            <div class="">
                                <a :href="$api.files.getOutsideFiles(getFilePath(applyData.form_file_url))">
                                    <i class="align-middle fas fa-fw fa-cloud-download-alt float-end"></i>
                                </a>
                                <label class="form-label">檔案</label>
                                <input class="form-control" type="text"
                                    :value="applyData.form_file_name"
                                    :disabled="true"
                                />
                            </div>
                        </div>

                        <div class="block-box mb-3 mb-xl-3">
                            <span class="block-title">檢驗報告</span>
                            <div class="">
                                <label class="form-label">檔案</label>
                                <input class="form-control mb-2" type="text"
                                    :value="applyData.result_file_name"
                                    :disabled="true"
                                />
                                <label class="btn btn-primary w-100">
                                    <i class="align-middle me-2 fas fa-fw fa-file-upload"></i>
                                    <span>請選擇檔案</span>
                                    <input
                                        type="file"
                                        style="display: none;"
                                        @change="handleReportFileChange"
                                    />
                                </label>
                            </div>
                        </div>
                    </div>
                    
					
                    <div class="text-center mt-3">
                        <button type="button"
                            class="btn btn-success w-100"
                            @click="uploadReport"
                        >上傳</button>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'testReportUpload',
    data(){
        return {
            id:parseInt( this.$route.params.id ),
            applyData:{
                id:null,
                exam_type:0,
                exam_unit:0,
                note:'',
                form_file_url:'',
                form_file_name:'',
                json_data:[],
                result_file_name:'',
                result_file_url:'',
                update_time:'',
                complete_time:'',
                form_send_time:''
            },
            applyTestList:[],
            exam_unit_List:[]
        }
    },
    components: {
        
    },
    methods:{
        async initView(){

            await this.getParameterOptions()

            this.$store.state.loadingStatus = true
            const res = await this.$api.exam.getExaminationGroupDetailByExamOutsideId({
                exam_outside_id: this.id
            })
            this.$store.state.loadingStatus = false
            console.log(res)
            if ( res.code !== 200 || res.data == null ){
                return
            }

            //呼叫另外一隻取得群組id
            this.$store.state.loadingStatus = true
            const groupRes = await this.$api.exam.getExaminationResultOutsideByOutsideId({
                outside_id: this.id
            })
            this.$store.state.loadingStatus = false
            if ( groupRes.code !== 200 || groupRes.data == null ){
                return
            }

            this.applyData = res.data
            this.applyData.exam_group_id = groupRes.data.exam_group_id
            this.applyData.complete_time = groupRes.data.complete_time
            this.applyData.form_send_time = groupRes.data.form_send_time
            this.applyData.specimen_type = groupRes.data.specimen_type
        },
        async getParameterOptions(){
            this.$store.state.loadingStatus = true
            const opRes = await this.$api.parameters.getParameterOptions({parameter_id:10})
            this.$store.state.loadingStatus = false
            if ( opRes.code !== 200 ){
                return
            }
            this.exam_unit_List = []
            for (let index = 0; index < opRes.data[0].options.length; index++) {
                const option = opRes.data[0].options[index];
                if ( option.is_enable ){
                        this.exam_unit_List.push({
                        id: option.id,
                        name: option.name
                    })
                }
            }
        },
        getExamTypeName(exam_type){
            const outSideItem = this.$parameters.outSide_list.find(item=>item.id===exam_type)
            return outSideItem ? outSideItem.name : 'N/A'
        },
        getSpecimenTypeName(specimen_type){
            const specimenTypeItem = this.$parameters.specimenTypes.find(item=>item.id===specimen_type)
            return specimenTypeItem ? specimenTypeItem.name : 'N/A'
        },
        getExamUnitName(exam_unit){
            const examUnitItem = this.exam_unit_List.find(item=>item.id===exam_unit)
            return examUnitItem ? examUnitItem.name : 'N/A'
        },
        getFilePath(fileString) {
            console.log(`fileString=`,fileString)
            if (!fileString){
                return ''
            }
            const result = fileString.split(',');
            console.log('getFilePath=',result)
            if ( result.length <=0 ){
                return result[0] || '';
            }
            return result[1] || '';
        },
        async handleReportFileChange(event){
            const file = event.target.files[0] ? event.target.files[0] : null
            if ( file == null ){
                return
            }
            let objFrom = new FormData()
            objFrom.append('files',file)
            this.$store.state.loadingStatus = true
            this.$store.state.progressStatue = true
            const res = await this.$api.files.uploadFiles(objFrom,(progress)=>{
                this.$debug('progress:',progress)
                this.$store.state.progressValue = progress.percentVal
            })
            this.$store.state.progressStatue = false
            this.$store.state.progressValue = 0
            this.$store.state.loadingStatus = false
            this.$debug('uploadFiles:',res)
            if (res.code !== 200){
                return alert('檔案上傳失敗，請檢查格式')
            }

            this.applyData.result_file_url = res.data.imgPath
            this.applyData.result_file_name = file.name
        },
        async uploadReport(){
            let objFrom = new FormData()
            objFrom.append('exam_group_id',this.applyData.exam_group_id)
            objFrom.append('result_file_url',this.applyData.result_file_url)
            objFrom.append('result_file_name',this.applyData.result_file_name)

            this.$store.state.loadingStatus = true
            const res = await this.$api.exam.updExaminationGroupResult(objFrom)
            this.$store.state.loadingStatus = false
            if ( res.code !== 200 ){
                this.$store.state.actionResult.show({status:'fail',massage:res.msg})
                return
            }
            this.$store.state.actionResult.show({status:'success',massage:'上傳成功'})

            this.$router.push(`/uploadSubmitted`)
        }
    },
    mounted(){
        this.initView()
    }

}
</script>
<style scoped>
.intake-view{
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative; /* 使 ::before 绝对定位相对于这个容器 */
    background-image: url('@/assets/img/wildoneHis/clouded leopard LOGO.png');
    background-repeat: no-repeat;
    background-size: 20rem;
    background-position-x: 6rem;
    background-position-y: 5rem;
}
.intake-view::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.4); /* 白色半透明，調整 alpha 值以改變壓淡程度 */
    z-index: 1; /* 讓遮罩在背景圖片上 */
}

.content {
    position: relative; /* 使内容在遮罩之上 */
    z-index: 2;
}
.intake-view > .card {
    min-width: 376px;
    width: 40%;
    max-width: 1024px;
    height: fit-content;
    z-index:2;
}

</style>
  